export class SupportRequiredInfo {
    RequestID: number;
    ProjectStartDate?: Date;
    ProjectEndDate?: Date;
    PPG?: string;
    Material?: string;
    CorrectedAmountToBeCharged?: number;
    TradeLetterPAW?: string;
    InvoiceDate?: Date;
    PostingDate?: Date;
    ReferenceNumber?: string;
    AmountToBeReinstated?: number;
    GLAccountNumber?: string;
    ProfitCenterCostCenter?: string;
    AdditionalText?: string;
    InvoiceNumber?: string;
    RequestedRefundInvoicePaid?: boolean;
    CanCreditOffsetBalance?: boolean;
    CustomerPaymentTypeID?: number;
    MOVOffDayFeeChargedAmount?: number;
    RefundSentToAddressOnFile?: boolean;
    SalesOfficeID?: number;
    RefundAddress?: string;
}

export default SupportRequiredInfo;